import { render, staticRenderFns } from "./criteria-multi-selector.vue?vue&type=template&id=8fb8bdb8&scoped=true&"
import script from "./criteria-multi-selector.vue?vue&type=script&lang=ts&"
export * from "./criteria-multi-selector.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-multi-selector.vue?vue&type=style&index=0&id=8fb8bdb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb8bdb8",
  null
  
)

export default component.exports